import * as angular from 'angular';
import {IController} from "angular";

export class DeliveriesGroupSelectorCtrl implements IController {
  selectedGroup: any;
  groupList: any;
  onChange: Function;

  private groupToBackground: any;

  /* @ngInject */
  constructor(private deliveriesConstants) {
  }

  $onInit() {
    this.groupToBackground = this.deliveriesConstants.groupToBackground;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onSelect(group) {
    this.onChange({group: group});
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesGroupSelector', {
    bindings: {
      selectedGroup: '<',
      groupList: '<',
      onChange: '&'
    },
    template: require('./deliveries-group-selector.html').default,
    controller: DeliveriesGroupSelectorCtrl
  });
